import { Button, Flex, Row } from 'antd';
import React from 'react';
import { ERoutesPrivate } from 'common/models/routesModel';
import { ReactComponent as BitecoinIcon } from 'app/assets/images/bitecoinIcon.svg';
import bitecoinInOrder from 'app/assets/images/bitecoinInOrder.png';
import { history } from 'app/store';
import { useAppSelector } from 'app/store/store.hooks';
import { EOrderStatus } from 'entities/Orders/Orders.models';

interface IComponentProps {
  orderStatus: EOrderStatus | undefined;
  earnedBitecoins: number;
}

export const BitecoinOrderWidget: React.FC<IComponentProps> = ({ orderStatus, earnedBitecoins }) => {
  const { bitecoinCustomerInfoModel } = useAppSelector((state) => state.bitecoin);
  const { bitecoins, bitecoinsLimit } = bitecoinCustomerInfoModel || {};
  const isLimitReached = bitecoins === bitecoinsLimit && orderStatus === EOrderStatus.Finished;

  const getTitle = () => {
    if (orderStatus === EOrderStatus.Finished) {
      if (bitecoins === bitecoinsLimit) {
        return 'Oops! You`ve reached a limit of your Bitecoin Wallet...';
      }

      return 'Hooray! You`ve earned...';
    }

    return 'Wow! For this order, you will earn*';
  };

  const getText = () => {
    if (orderStatus === EOrderStatus.Finished) {
      if (bitecoins === bitecoinsLimit) {
        return 'Redeem rewards to get new ones!';
      }

      return !!bitecoins && `Your new balance is ${bitecoins} bitecoins!`;
    }

    return '*You`ll get your bitecoins once the order is complete';
  };

  const goToRewards = () => history.push(ERoutesPrivate.Bitecoin);

  const title = getTitle();
  const text = getText();

  return (
    <div className="bitecoin-order__widget-wrapper mb-7">
      <Flex vertical>
        <span className="fs-sm font-weight-7 t-align-c">{title}</span>
        <Row align="middle" justify="center" className="mt-5 mb-5 t-align-c">
          <BitecoinIcon />
          <span className="bitecoin-wallet__balance-widget__sum">{isLimitReached ? bitecoinsLimit : earnedBitecoins}</span>
        </Row>
        <span className="bitecoin-wallet__balance-widget__tooltip t-align-c">{text}</span>
      </Flex>
      {isLimitReached ? (
        <Button size="large" block className="btn" type="primary" onClick={goToRewards}>
          Redeem Rewards
        </Button>
      ) : (
        <img src={bitecoinInOrder} width={200} alt="bitecoins" className="bitecoin-order__widget-image" />
      )}
    </div>
  );
};
